<!-- eslint-disable vue/multi-word-component-names -->
<template> 
  <!--MICHAEL: 
    Snackbar needs to show up on submit then close after delay.
    Popup needs to close on submit.
    ProductTitle and ProductVariant
  -->
  <button
    class="btn btn-secondary text-secondary-content"
    @click="prep(); showReviewPopup=true"
  >
    Leave a Review
  </button>
  <PopUp v-if="showReviewPopup">
    <template #popuptitle>
      Leave a Review
    </template>
    <template #exitbtn> 
      <button
        class="w-full h-full"
        @click="showReviewPopup=false"
      >
        X
      </button>
    </template>
    <p class="text-2xl text-center">
      {{ productTitle }}
    </p>
    <v-rating
      v-model="rating"
      clearable
      hover
    /> 
    <!-- <div class="rating rating-lg gap-1 justify-center w-full mt-n4">
      <input
        type="radio"
        name="rating-3"
        class="mask mask-heart"
      >
      <input
        type="radio"
        name="rating-3"
        class="mask mask-heart"
      >
      <input
        type="radio"
        name="rating-3"
        class="mask mask-heart"
        checked
      >
      <input
        type="radio"
        name="rating-3"
        class="mask mask-heart"
      >
      <input
        type="radio"
        name="rating-3"
        class="mask mask-heart"
      >
    </div> -->
    <br>
    <br>
    <v-textarea
      v-model="reviewText"
      type="text"
      label="Message"
    />
    <div class="twocolinputs">
      <button
        class="btn btn-secondary text-secondary-content"
        @click="showReviewPopup = false; reviewText=''"
      >
        Discard Review 
      </button>
      <button 
        class="btn btn-secondary text-secondary-content"
        @click="submitReview(); showReviewPopup=false; showSnackbar();"
      >
        Submit Review
      </button>
    </div>
  </PopUp>
  <div 
    v-if="reviewSubmitSnackbar"
    class="snackbar elevation-10 text-center"
  >
    <p>Thank you for your input!<br>Your review has been posted.</p>
  </div>
</template>

<script setup>
import { doc, getDoc, setDoc } from 'firebase/firestore';

const props = defineProps({
  id:{
    type:String,
    required:true
  },
  productTitle:{
    type:String,
    required:true
  }
});
const emit = defineEmits(['reviewSubmitted']);
const itemId = ref(computed(()=>{return props.id}))
const productTitle = ref(computed(()=>{return props.productTitle}))

const showReviewPopup = ref(false)
const reviewSubmitSnackbar = ref(false)
// const files = ref([])

const rating = ref()
const reviewText = ref()

const reviewDocRef = doc(useFirestore(),'products',itemId.value,'reviews',useCurrentUser().value.uid)


const prep = () => {
  if(useCurrentUser().value){
    getDoc(reviewDocRef).then((duck)=>{
      if(duck.exists()){
        rating.value = duck.get('stars')
        reviewText.value = duck.get('msg')
      }
    })
  }
}

const submitReview = async() => {
  if(useCurrentUser().value){
    const reviewDocRef = doc(useFirestore(),'products',itemId.value,'reviews',useCurrentUser().value.uid)
    //The setDoc should only work if the user passes firestore rules
    await setDoc(reviewDocRef,{
      stars:rating.value,
      msg:reviewText.value,
      displayName:useCurrentUser().value.displayName===null ? "Unnamed User" : useCurrentUser().value.displayName,
      author:useCurrentUser().value.uid
    })
    emit('reviewSubmitted')
  } 
}

const showSnackbar = async () => {
  reviewSubmitSnackbar.value=true
  await delay(3210)
  reviewSubmitSnackbar.value=false
}

const delay = ms => new Promise(res => setTimeout(res, ms));

</script>